import { Controller } from "@hotwired/stimulus"
import { errorDetail, formatDate, formatPln, getJSON, listResults, sendJSON } from "../api.js"

// Portfel organizacji: split salda (wpłacone brutto / bonus netto / razem brutto),
// doładowanie (POST /api/wallet/topup/ → paid od razu albo redirect do bramki)
// i historia środków z kieszenią.
export default class extends Controller {
  static targets = [
    "rows", "status",
    "deposited", "bonus", "total",
    "topupAmount", "topupBtn", "topupError",
  ]
  static values = {
    url: String,       // /api/credits/
    walletUrl: String, // /api/wallet/balance/
    topupUrl: String,  // /api/wallet/topup/
  }

  static POCKET_LABEL = { deposited: "Wpłacone", bonus: "Bonus" }

  connect() { this.load() }

  async load() {
    let list
    let wallet
    try {
      ;[list, wallet] = await Promise.all([
        getJSON(this.urlValue),
        getJSON(this.walletUrlValue),
      ])
    } catch {
      this.#status("Nie udało się załadować portfela. Odśwież stronę.")
      return
    }
    if (this.hasDepositedTarget) this.depositedTarget.textContent = formatPln(wallet.deposited_pln)
    if (this.hasBonusTarget) this.bonusTarget.textContent = formatPln(wallet.bonus_pln)
    if (this.hasTotalTarget) this.totalTarget.textContent = formatPln(wallet.total_available_gross_pln)

    const credits = listResults(list)
    this.rowsTarget.textContent = ""
    if (!credits.length) {
      this.#status("Brak środków w historii.")
      return
    }
    this.#status(null)
    const template = document.getElementById("credit-row-template")
    for (const credit of credits) {
      const row = template.content.firstElementChild.cloneNode(true)
      row.querySelector('[data-field="pocket"]').textContent =
        this.constructor.POCKET_LABEL[credit.pocket] ?? credit.pocket
      row.querySelector('[data-field="amount"]').textContent = formatPln(credit.amount_pln)
      row.querySelector('[data-field="note"]').textContent = credit.note || "—"
      row.querySelector('[data-field="complaint"]').textContent =
        credit.complaint ? `reklamacja #${credit.complaint}` : "—"
      row.querySelector('[data-field="created"]').textContent = formatDate(credit.created)
      this.rowsTarget.appendChild(row)
    }
  }

  // Doładowanie portfela: paid=true (dev AutoPaid) → odśwież saldo/historię;
  // redirect_url (P24) → przejście do bramki.
  async topup() {
    const amount = this.hasTopupAmountTarget ? this.topupAmountTarget.value.trim() : ""
    if (!amount) {
      this.#topupError("Podaj kwotę doładowania.")
      return
    }
    if (this.hasTopupBtnTarget) this.topupBtnTarget.disabled = true
    const res = await sendJSON("POST", this.topupUrlValue, { amount_pln: amount })
    if (this.hasTopupBtnTarget) this.topupBtnTarget.disabled = false
    if (!res.ok) {
      this.#topupError(errorDetail(res.data, "Nie udało się doładować portfela."))
      return
    }
    this.#topupError(null)
    if (res.data?.redirect_url) {
      this.redirect(res.data.redirect_url)
      return
    }
    if (this.hasTopupAmountTarget) this.topupAmountTarget.value = ""
    await this.load()
  }

  // Wydzielone do spy w testach (jsdom nie implementuje nawigacji window.location).
  redirect(url) {
    window.location.assign(url)
  }

  // --- prywatne ---

  #topupError(message) {
    if (!this.hasTopupErrorTarget) return
    this.topupErrorTarget.hidden = message === null
    if (message !== null) this.topupErrorTarget.textContent = message
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
